import { NgModule } from '@angular/core';
import { PermissionDirective } from './permission.directive';
import { MatSelectRemoveAriaOwnsDirective } from './mat-select-remove-aria-owns.directive';

@NgModule({
  imports: [],
  declarations: [PermissionDirective, MatSelectRemoveAriaOwnsDirective],
  exports: [PermissionDirective, MatSelectRemoveAriaOwnsDirective]
})
export class DirectivesModule { }